<template>
  <model-form
    ref="form"
    :model="orderItem"
    :submodel="true"
    modal-type="maximized-modal"
    :maximized-width="$q.screen.gt.xs && $isLandscapeView() ? '90%' : ''"
    :maximized-height="$q.screen.gt.xs && $isLandscapeView() ? '90%' : ''"
    :embedded-in-model-table="false"
    :show-and-close="false"
    :revert-label="'Undo'"
    max-content-width="100%"
    close-on-save
    hide-title
    :btn-position-fixed-bottom="$q.screen.lt.sm || !$isLandscapeView()"
    :btn-position-absolute-bottom-left="!$q.screen.lt.sm && $isLandscapeView()"
    btn-floating-right
    btn-outline
    :btn-large="$q.screen.gt.xs"
    btn-show-title
    btn-hide-icon
    centered
    show-detail
    :none-padding="$q.screen.lt.sm || !$isLandscapeView()"
    :flex-grow="false"
    :zoom="kioskViewPortZoom"
    @change="orderItem => $emit('change', orderItem)"
    @add-model="orderItem => $emit('add-model', orderItem)"
  >
    <template
      #title
    >
      <div
        class="q-px-sm"
      >
        to Cart
        (
        <slot
          name="buttonSubtitle"
        >
          <i18n-n
            :value="orderItem.displayPrice || 0"
            format="currency"
          />
        </slot>
        )
      </div>
    </template>

    <div
      v-if="orderItem.type === 'item'"
      :class="{
        'row justify-between absolute-full': !$q.screen.lt.sm && $isLandscapeView(),
        'q-pt-xl': !orderItem.item.highResImageUrl && ($q.screen.lt.sm || !$isLandscapeView()) || $mobileRegister()
      }"
      :style="{ height: $q.screen.lt.sm || !$isLandscapeView() ? '' : '100%' }"
    >
      <div
        class="col relative-position"
        :class="{
          'col-4 q-pt-lg q-pr-xl q-pl-lg': !$q.screen.lt.sm && $isLandscapeView(),
          'border-bottom': $q.screen.lt.sm || !$isLandscapeView()
        }"
        :style="{ height: $q.screen.lt.sm || !$isLandscapeView() ? '' : '88%' }"
      >
        <age-restricted-banner
          v-if="orderItem?.item?.showAlcoholAcknowledgement"
        />
        <q-img
          v-if="!!orderItem.item.highResImageUrl && !$mobileRegister()"
          :class="{ 'col-6': $q.screen.lt.sm || !$isLandscapeView() }"
          :style="{ 'max-height': !$isLandscapeView() && $q.screen.gt.xs ? '28vh' : undefined }"
          :ratio="16/9"
          :src="orderItem.item.highResImageUrl"
        />

        <div
          :class="{ 'q-px-md q-py-sm': $q.screen.lt.sm || !$isLandscapeView() }"
        >
          <div
            :class="{
              'text-h5 text-bold': $q.screen.lt.sm || !$isLandscapeView(),
              'text-h3': !$q.screen.lt.sm && $isLandscapeView()
            }"
          >
            <slot name="title">
              {{ orderItem.title }}
            </slot>
          </div>

          <template v-if="orderItem.item.description">
            <p
              class="scroll"
              :class="readMore && orderItem.item.description.length > 300 ? 'ellipsis-3-lines': ''"
              :style="{ 'max-height': $q.screen.gt.sm && $q.screen.lt.lg ? '200px' : undefined }"
            >
              {{ orderItem.item.description }}
            </p>
            <q-btn
              v-if="orderItem.item.description.length > 300"
              flat
              padding="none"
              size="md"
              class="block q-mt-sm"
              @click="readMore =! readMore"
            >
              <span v-if="readMore">{{ $t('nav.actions.readMore') }} <span class="material-icons"> expand_more</span></span>
              <span v-else>{{ $t('nav.actions.readLess') }} <span class="material-icons"> expand_less</span></span>
            </q-btn>
          </template>
          <template v-if="!$q.screen.lt.sm && $isLandscapeView() ">
            <div class="absolute-bottom q-py-sm q-pl-lg">
              <slot
                name="price"
              >
                <div class="text-h4 text-responsive-grey">
                  Total: <i18n-n
                    class="text-h4 text-responsive"
                    tag="span"
                    :value="orderItem.displayPrice || 0"
                    format="currency"
                  />
                </div>
              </slot>
            </div>
          </template>
        </div>
      </div>

      <slot
        name="item-detail"
        :order-item="orderItem"
        :available-online="availableOnline"
      >
        <item-detail
          ref="itemDetail"
          :hide-delivery-type="hideDeliveryType"
          class="col-12 col-sm-8"
          :class="{ 'q-pa-md scroll': $q.screen.gt.xs && $isLandscapeView() }"
          :style="{ height: $q.screen.gt.xs && $isLandscapeView() ? '100%' : undefined }"
          :order-item="orderItem"
          :available-online="availableOnline"
          @request-authorization="callback => $emit('request-authorization', callback)"
          @merge-tab="foundOrder => $emit('merge-tab', foundOrder)"
        />
      </slot>
    </div>

    <ticket-detail
      v-if="orderItem.type === 'ticket'"
      :order-item="orderItem"
    />
  </model-form>
</template>

<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import AgeRestrictedBanner from 'src/modules/checkout/components/AgeRestrictedBanner'
import ItemDetail from 'src/modules/register/components/order-item-form/components/ItemDetail'
import TicketDetail from 'src/modules/register/components/order-item-form/components/TicketDetail'
export default {
  name: 'OrderItemForm',
  components: {
    ModelForm,
    ItemDetail,
    TicketDetail,
    AgeRestrictedBanner
  },
  context: ['currentRegisterClient'],
  configuration: ['currentSite'],
  props: {
    availableOnline: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  models: {
    orderItem: {
      order: 'default',
      itemOrderItem: {
        itemVariation: true,
        itemModifiers: {
          itemModifiers: {
            modifier: true
          }
        }
      }
    }
  },
  emits: ['change', 'add-model', 'request-authorization', 'merge-tab'],
  data () {
    return {
      readMore: true
    }
  },
  computed: {
    kioskViewPortZoom () {
      if (this.$q.platform.is.iphone || this.$q.platform.is.ipad || this.$q.platform.is.android || this.$q.platform.is.blackberry || this.$q.platform.is.winphone || this.$q.platform.is.kindle) return 1
      return this.currentRegisterClient?.registerStation?.registerType?.kioskViewPortZoom || 1
    },
    hideDeliveryType () {
      return this.$mobileRegister() && this.currentRegisterClient?.registerStation?.registerType?.promptForDeliveryOnMobile
    }
  },
  methods: {
    show (model, initialData) {
      this.$refs.form.show(model, initialData)
    },
    setCollection (collection) {
      this.$refs.form.model.setParent(collection)
    }
  }
}

</script>
